module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-field  cb-field--select",
    class: [{
      'cb-field--active': _vm.internalValue || _vm.focussed || _vm.defaultVal
    }, _vm.customClass, {
      'cb-field--focus': _vm.focussed
    }, {
      'cb-field--error': !!_vm.errorMessage && !_vm.focussed
    }, {
      'cb-field--sibling': _vm.siblingError
    }, {
      'cb-field--select-alt': this.config.meta.help_text
    }, {
      'cb-field--select-readonly': _vm.readonly
    }]
  }, [_c('label', {
    staticClass: "cb-field__label",
    class: {
      'cb-field__label--s': _vm.isShort
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(" " + _vm._s(_vm.displayLabel) + "\n  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalValue),
      expression: "internalValue"
    }],
    ref: "select",
    staticClass: "cb-field__control",
    class: {
      'cb-field__readonly': _vm.readonly
    },
    attrs: {
      "type": "text",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "autocomplete": _vm.autocompleteMapping,
      "name": _vm.name,
      "id": _vm.name,
      "aria-required": _vm.required
    },
    on: {
      "click": function($event) {
        _vm.focus($event)
      },
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.internalValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.change($event)
      }],
      "input": function($event) {
        _vm.input($event)
      }
    }
  }, [(_vm.showDefault) ? _c('option', {
    attrs: {
      "selected": "selected",
      "disable": "disable",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.st('select_field_default')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.allowedValues()), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option.value || option
      }
    }, [_vm._v("\n      " + _vm._s(option.display_name || option) + "\n    ")])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "cb-field__label",
    class: {
      'cb-field__label--s': _vm.isShort
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(" " + _vm._s(_vm.displayLabel))]), _vm._v(" "), (this.config.meta.help_text) ? _c('div', {
    staticClass: "cb-field__help"
  }, [
    [_c('div', {
      ref: "helpText",
      staticClass: "cb-field__trigger",
      class: {
        'active-opacity': _vm.helpTextShown
      },
      on: {
        "click": function($event) {
          _vm.showHelpText($event)
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "help-text"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.helpTextShown),
        expression: "helpTextShown"
      }],
      staticClass: "cb-field__menu"
    }, [_vm._v("\n          " + _vm._s(this.config.meta.help_text) + "\n        ")])])]
  ], 2) : _vm._e(), _vm._v(" "), (!_vm.focussed && _vm.errorMessageWrapper) ? _c('div', {
    staticClass: "cb-field__error"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessageWrapper) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff3401bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/SelectField.vue
// module id = 125
// module chunks = 65 66 67 68